<!--/*
PreviewURL
Artist/ArtistName
TrackId
Name/SongName
Image
SpotifyArtistId
Duration
*/-->
<template>
    <div class="song-cite song-bar-container" :id="thisTrack.elemId">
        <div class="preview-player"><audio controls @timeupdate="onTimeUpdate(thisTrack)" ref="audio"><source :src="thisTrack.PreviewURL" type="audio/mpeg"/></audio></div>

        <div class="soundclip soundtype-feature">
            <div :v-if="showHideUI" @click.stop="stopTrack()" class="hide-all"></div>
            <div  class="discover-card"  @click.stop="selectTrack(thisTrack)">
                <background-image  :src="thisTrack.SongImage" class="discover-card-bg">
                    <div class="track-info" v-if="!hideInfo">
                        <span class="song-name">{{getTrackName(thisTrack)}}</span>
                        <span class="artist-name">{{thisTrack.Artist}}</span>
                    </div>
                    <div class="song-rating-ui toggle-pause song-ui">
                        <button class="toggle-play-button" @click.stop="stopTrack()"><font-awesome-icon class="rating-icon" :icon="['fas', 'pause']"></font-awesome-icon></button>
                    </div>
                    <div class="toggle-play song-ui" v-if="!hideTogglePlay">
                        <button class="toggle-play-button" @click.stop="toggleTrackPlay(thisTrack, $event)"><font-awesome-icon class="rating-icon icon-play" :icon="['fas', 'play']"></font-awesome-icon></button>
                    </div>
                    <div class="toggle-play song-ui" v-else>
                        <button class="toggle-play-button" @click.stop="onOpenInSpotify(thisTrack)"><font-awesome-icon class="rating-icon spotify" :icon="['fab', 'spotify']"></font-awesome-icon></button>
                    </div>
                    <span class="duration"  v-if="!hideInfo">{{formatMSToTime(thisTrack.Duration)}}</span>
                    <div class="track-sidebar-cta" v-if="!nocontrols">
                        <button class="icon-btn" @click.stop="onAddTrack(thisTrack, $event)" title="Add To Playlist"><font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon></button>
                        <button class="icon-btn" @click.stop="onShareTrack(thisTrack, $event)" title="Share Track"><font-awesome-icon :icon="['fas', 'share']"></font-awesome-icon></button>
                        <button class="icon-btn" @click.stop="onThumbUp(thisTrack, $event)" title="Liked it!"><font-awesome-icon :icon="['fas', 'thumbs-up']"></font-awesome-icon></button>
                        <button class="icon-btn" @click.stop="onThumbDown(thisTrack)" title="Didn't Like it..."><font-awesome-icon :icon="['fas', 'thumbs-down']"></font-awesome-icon></button>
                        <button class="icon-btn" @click.stop="onOpenInSpotify(thisTrack)" title="Listen in Spotify"><font-awesome-icon :icon="['fab', 'spotify']"></font-awesome-icon></button>
                    </div>
                </background-image>
                <div class="song-bar">
                    <div class="song-progress" :style="'width:' + currentPlayPercentage + '%'"></div>
                    <div class="song-info">

                    </div>
                </div>
                <div :v-if="showHideUI" @click.stop="stopTrack()" class="hide-me"></div>
            </div>
        </div>

    </div>
</template>

<script>

import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import pcShared from '@/shared/shared';
import { main, shared } from '@/main';
import BackgroundImage from '@/components/BackgroundImage.vue';

export default {
  name: 'SongPreview',
  data() {
    return {
      currentTime: 0,
      currentPlayPercentage: 0,
      hideTogglePlay: false,
      activeTrack: null,
      elemId: null,
      thisTrack: null,
      savedSearchInteraction: false,
    };
  },
  /* ready: function () {
        new MediaElementPlayer(this.$refs.audio);
    }, */
  components: {
    FontAwesomeIcon,
    BackgroundImage,
  },
  props: {
    track: Object,
    expanded: Boolean,
    ignoreListen: Boolean,
    avoidClick: Boolean,
    showHideUI: Boolean,
    addTrackToPlaylist: Function,
    nocontrols: Boolean,
    hideInfo: Boolean,
  },
  computed: {

  },
  /* created(){
      shared.$on('player-clicked', (track) =>{
          this.onToggle
      })
  },
  watch:{
      track(){
          this.verifyTrack();

      }
  }, */
  methods: {
    verifyTrack() {
      if (this.track != null) {
        this.thisTrack = this.track;
        if (this.thisTrack.PreviewURL == '' || this.thisTrack.PreviewURL == undefined || this.thisTrack.PreviewURL == null) {
          if (this.thisTrack.PreviewUrl) this.thisTrack.PreviewURL = this.thisTrack.PreviewUrl;
          else if (this.thisTrack.SongPreviewURL != null && this.thisTrack.SongPreviewURL != '' && this.thisTrack.SongPreviewURL != undefined) {
            this.thisTrack.PreviewURL = this.thisTrack.SongPreviewURL;
          } else if (this.thisTrack.SongPreviewUrl != null && this.thisTrack.SongPreviewUrl != '' && this.thisTrack.SongPreviewUrl != undefined) {
            this.thisTrack.PreviewURL = this.thisTrack.SongPreviewUrl;
          } else {
            this.thisTrack.PreviewURL = '';
          }
        }
        if (this.thisTrack.TrackId == '' || this.thisTrack.TrackId == null || this.thisTrack.TrackId == undefined && this.thisTrack.SongId != '' && typeof (this.thisTrack.SongId) !== 'undefined') {
          this.thisTrack.TrackId = this.thisTrack.SongId;
        }
        if (this.thisTrack.PreviewURL == '' || this.thisTrack.PreviewURL == undefined || this.thisTrack.PreviewURL == null) this.hideTogglePlay = true;
        if (!this.thisTrack.Duration) this.thisTrack.Duration = this.thisTrack.SongDuration;
        this.thisTrack.elemId = `song-bar-${this.thisTrack.TrackId}_${Date.now()}`;
        this.thisTrack.ignoreListen = this.ignoreListen;
        if (this.thisTrack.Artist != '' && !this.thisTrack.ArtistName) {
          this.thisTrack.ArtistName = this.thisTrack.Artist;
        } else if ((this.thisTrack.ArtistName != '' && this.thisTrack.ArtistName != undefined && this.thisTrack.ArtistName != null) && (!this.thisTrack.Artist || this.thisTrack.Artist == '')) {
          this.thisTrack.Artist = this.thisTrack.ArtistName;
        }
      }
    },
    onCancelHideRecentSearches() {
      shared.$emit('onCancelHideRecentSearches', true);
    },
    onSearchInteraction(track, status) {
      if (!this.savedSearchInteraction) {
        const searchSuccess = {};
        searchSuccess.BatchId = shared.generateUUID();
        searchSuccess.Type = 'SearchSuccess';
        searchSuccess.dbUserId = shared.user.Id;
        searchSuccess.dbPlaylisterId = shared.user.Id;
        searchSuccess.SongImage = track.Image;
        searchSuccess.SongPreviewURL = track.PreviewURL;
        searchSuccess.SpotifyPlaylisterId = shared.user.SpotifyArtistId;
        searchSuccess.SpotifySongId = track.TrackId;
        searchSuccess.SongDuration = track.Duration;
        searchSuccess.SongName = track.SongName;
        searchSuccess.Status = status;
        searchSuccess.SpotifyArtistId = track.SpotifyArtistId;
        searchSuccess.SongSpotifyArtistId = track.SpotifyArtistId;
        searchSuccess.SongSpotifyArtistName = track.ArtistName;
        if (typeof (track.dbArtistId) !== 'undefined') {
          searchSuccess.dbArtistId = track.dbArtistId;
        }
        shared.saveTransaction(searchSuccess);
        console.log('interaction saved', searchSuccess);
        this.savedSearchInteraction = true;
      }
    },
    onOpenInSpotify(track) {
      window.open(`https://open.spotify.com/track/${track.TrackId}`);
    },
    onAddTrack(track, event) {
      // shared.onAddTrack(track, event, null);
    },
    checkForClick(track, event) {
      if (!this.avoidClick) {
        event.stopPropagation();
        this.toggleTrackPlay(track, event);
      }
    },
    getTrackName(track) {
      // if (track.Name) return track.Name;
      return track.SongName;

      // track.SongName || track.Name
    },
    getArtistName(track) {
      return track.ArtistName;
    },
    onTimeUpdateListener() {
      // Update current time
      this.currentTime = this.$els.audioPlayer.currentTime;
    },
    onTimeUpdate(track) {
      if (this.activeTrack && this.activeTrack == track) {
        if ($('.song-bar-container.playing').find('audio').length > 0) {
          const velem = $('.song-bar-container.playing').find('audio')[0];
          const listenedTo = velem ? velem.currentTime : 0;
          let trackDuration;
          if (track.Duration && false) { // only showing 30 sec previews
            trackDuration = track.Duration / 1000;
          } else {
            trackDuration = 30;
          }
          this.currentPlayPercentage = listenedTo / trackDuration * 100;
        }
      }
    },
    calculatePlayPerc() {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.currentTime;
      }
    },

    toggleTrackPlay(track, event) {
      this.onTogglePlay(track);
    },
    onTogglePlay(track) {
      this.stopTrack();
      console.log('toggling track', track);
      if (this.activeTrack != track) this.selectTrack(track);
      if (this.activeTrack != null && this.activeTrack != undefined) {
        const isSameTrack = (this.activeTrack.TrackId == track.TrackId);

        this.stopTrack();

        if (!isSameTrack) {
          this.playTrack(track, event);
        }
      } else {
        this.playTrack(track, event);
      }
    },
    /*
        computedSongId: function(track){
            var elemId;
            console.log('watchagot?', track);
            if(track!=null){
                if(this.view=='community')
                    elemId =  'song-bar-' + track.TransactionId + '_' + track.TrackId + '_' + this.view;
                else
                    elemId = 'song-bar-' + track.TrackId + '_' + this.view;
                track.elemId = elemId;
                return elemId;
            }else{
                return 'song-bar-dashboard-' + Date.now();
            }
        },
        */
    playTrack(track, event) {
      // console.log(track);
      //  console.log($(event.target).closest('.song-bar-container').attr('id'), track.elemId);
      // stop video track player

      shared.$emit('stopVideoTrackPlayer', null);
      if ($(`#${track.elemId}`).find('audio').length > 0 && track.PreviewURL != '' && track.PreviewURL != undefined) {
        $('.song-cite.selected').removeClass('selected');
        $(`#${track.elemId}`).addClass('playing selected');

        $('.app').addClass('sc-playing');
        $(`#${track.elemId}`).find('audio')[0].play();
        shared.activeTrack = track;
        shared.$emit('activeTrackUpdated', track);
      } else {
        console.log('Song Preview not found.', track);
      }
    },
    selectTrack(track) {
      this.stopTrack();
      $('.song-cite.selected').removeClass('selected');
      $(`#${track.elemId}`).addClass('selected');
      shared.$emit('featureTrackSelected', track);
    },
    stopTrack() {
      try {
        this.stopActiveTrack();
      } catch (error) {
        console.log('song preview not found.');
      }
    },
    stopActiveTrack() {
      /* ===========================
      Uses global variable activeTrack
      to find currently playing element, pause it,
      and if needed (!ignoreListen & listenedTo>threshold) saves the listen.
      ============================== */
      if ($('.song-cite.playing')) {
        if (shared.activeTrack) {
          console.log($(`#${shared.activeTrack.elemId}`).find('audio')[0]);
          try {
            // $('.song-cite.playing audio')[0].pause();

            $(`#${shared.activeTrack.elemId}`).find('audio')[0].pause();
          } catch (err) {
            console.log(err);
          }
          $('.song-cite.playing').removeClass('playing');
          $('.app.sc-playing').removeClass('sc-playing');
        }
        shared.activeTrack = null;
        shared.$emit('activeTrackUpdated', null);
      }
    },
    dislikeTrack(track) {
      $(`#${track.elemId}`).addClass('disliked');
      $(`#${track.elemId}`).closest('li').addClass('disliked');
      $(`#${track.elemId}`).closest('.discover-slide').addClass('disliked');
      if ($('.song-cite.playing')) {
        if (track) {
          if ($(`#${track.elemId}`).find('audio')[0]) {
            $(`#${track.elemId}`).find('audio')[0].pause();
          }
          $(`#${track.elemId}`).removeClass('playing');
          $('.app.sc-playing').removeClass('sc-playing');
        }
        shared.activeTrack = null;
        shared.$emit('activeTrackUpdated', null);
      }
    },
    onThumbUp(track, event) {
      shared.$emit('onReviewTrack', track);
      shared.$emit('onReviewEvent', event);
      const myheaders = shared.getAuthHeaders();
      const ratingObj = {};
      const velem = $(`#${track.elemId}`).find('audio')[0];

      const listenedTo = velem.currentTime;

      ratingObj.BatchId = shared.generateUUID();
      ratingObj.Type = 'ThumbsUp';
      ratingObj.dbUserId = shared.user.Id;
      ratingObj.dbPlaylisterId = shared.user.Id;
      ratingObj.SongImage = track.Image;
      ratingObj.SongPreviewURL = track.PreviewURL;
      ratingObj.SpotifyPlaylisterId = shared.user.SpotifyArtistId;
      ratingObj.SpotifySongId = track.TrackId;
      ratingObj.DiscoverDuration = listenedTo;
      ratingObj.SongDuration = track.Duration;
      ratingObj.SongName = track.SongName;
      ratingObj.SpotifyArtistId = track.SpotifyArtistId;
      ratingObj.SongSpotifyArtistId = track.SpotifyArtistId;
      ratingObj.SongSpotifyArtistName = track.ArtistName;
      if (typeof (track.dbArtistId) !== 'undefined') {
        ratingObj.dbArtistId = track.dbArtistId;
      }
      this.$http.post(`${shared.root}/dataentry/insert/PlaylisterClub/PC_Transactions`, ratingObj, { headers: myheaders })
        .then((response) => {
          // success callback

        }, (error) => {
          // error callback
          console.warn(error);
        });
    },
    onThumbDown(track) {
      const vm = this;
      const myheaders = shared.getAuthHeaders();
      const ratingObj = {};
      const velem = $(`#${track.elemId}`).find('audio')[0];

      const listenedTo = velem.currentTime;

      ratingObj.BatchId = shared.generateUUID();
      ratingObj.Type = 'ThumbsDown';
      ratingObj.dbUserId = shared.user.Id;
      ratingObj.dbPlaylisterId = shared.user.Id;
      ratingObj.SongImage = track.Image;
      ratingObj.SongPreviewURL = track.PreviewURL;
      ratingObj.SpotifyPlaylisterId = shared.user.SpotifyArtistId;
      ratingObj.SpotifySongId = track.TrackId;
      ratingObj.DiscoverDuration = listenedTo;
      ratingObj.SongDuration = track.Duration;
      ratingObj.SongName = track.SongName;
      ratingObj.SpotifyArtistId = track.SpotifyArtistId;
      ratingObj.SongSpotifyArtistId = track.SpotifyArtistId;
      ratingObj.SongSpotifyArtistName = track.ArtistName;
      if (typeof (track.dbArtistId) !== 'undefined') {
        ratingObj.dbArtistId = track.dbArtistId;
      }
      this.$http.post(`${shared.root}/dataentry/insert/PlaylisterClub/PC_Transactions`, ratingObj, { headers: myheaders })
        .then((response) => {
          // success callback
          vm.dislikeTrack(track);
        }, (error) => {
          // error callback
          console.warn(error);
        });
    },
    onShareTrack(track, $event) {
      shared.shareTrack(track, $event);
    },

  },
  beforeMount() {
    this.verifyTrack();
  },
  mounted() {
    const vcin = this;
    this.activeTrack = shared.activeTrack;
    $('.preview-player audio').on('ended', () => {
      vcin.stopTrack();
    });
    shared.$on('activeTrackUpdated', (track) => {
      this.activeTrack = track;
    });
    //  console.log('songcite mounted');
    //  console.warn(this.track);
  },
/*
   "Id": "37i9dQZF1DX4dyzvuaRJ0n",
    "Name": "mint",
    "SpotifyUser": "spotify",
    "TotalTracks": 59,
    "Description": "The dance music condition with DJ Snake and Eptic.",
    "Image": "https://pl.scdn.co/images/pl/default/b9609f00d0becbac2a4c8ebfcda78d5259552ce1",
    "Followers": 5447285
  */
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "@/assets/scss/pcvariables.scss";
    .shadow{
    box-shadow: 0 5px 20px rgba($color-black, 0.5);
    }
    .text-shadow{
        text-shadow: 0 2px 5px rgba($color-black, 0.75);
    }
    .gradient{
        background: linear-gradient(to top, rgba($color-black,1), rgba($color-black,0.0));

    }
    .cropped{
        overflow:hidden;
        height:auto;
        width:auto;
        min-height: 100px;
        position:relative;
    }
    .background-image{
        position:absolute;
        z-index:1;
        top:0;
        bottom:0;
        left:0;
        right:0;
        background-size:cover;
        background-position: center center;
        filter: blur(20px);
       //filter:none;
       //display:none !important;
        opacity:0.5;
    }
    .spotify-link{
        font-size:16px;
        position:absolute;
        opacity: 0.8;
        display:none;
        cursor:pointer;

    }
    .spotify-link, .ac-spotify{
         &:hover{
            opacity:1;
            color: #1DB954;
        }
    }
    .track-sidebar-cta{
        position: absolute;
        right:-35px;
        z-index:9999999999;
        top:-2px;
        display:none;
        flex-direction:column;
        button{
            margin:0 !important;
            padding: 0.35rem 0.75rem;
            border-radius: 0;
        }
    }
    .soundclip{
        flex:1;
        display:flex;
        flex-flow: nowrap;
        position:relative;
    }
    .success{
        color: $color-secondary;
    }
    .fail{
        color: $color-danger;
    }
    .app.sc-playing .song-cite {
        z-index:0;
        .hide-me{display:block;}
        &.playing{
            opacity:1;
            z-index:9999999;
            .soundclip{border-color: $color-secondary;}
            .hide-me{
                display:none !important;
            }
            .song-progress{
                background-color: $color-secondary !important;
            }
            .toggle-play{
                .icon-play{
                    display:none !important;
                }
                .icon-paused{
                    display:flex;
                }
            }

        }
    }
    .selected{
        opacity:1;
            z-index:9999999;
            .soundclip{border-color: $color-secondary !important;}
    }
    .song-cite:hover, .selected.song-cite{
        .soundclip{border-color: $color-secondary !important;}
        .soundtype-card, .soundtype-suggestion, .soundtype-bar1  {
            .spotify-link{
                display:block;
                z-index:5;
                right:0.25rem;
                top:50%;
                transform: translateY(-50%);
            }
        }
        .soundtype-card, .soundtype-suggestion{
            .spotify-link{
                right:40px;
            }
        }
    }
    /*
    .song-cite:hover .soundtype-card .spotify-link, .song-cite:hover .soundtype-bar1 .spotify-link, .selected .spotify-link{
        display:block;
        z-index:5;
        right:0.25rem;
        top:50%;
        transform: translateY(-50%);
    }
    .song-cite:hover .soundtype-card .spotify-link, .selected.song-cite .soundtype-card .spotify-link{
        right: 40px;
    }
    */
    .selected .track-sidebar-cta, .playing .track-sidebar-cta{
      //  display:flex;
    }
    .hide-me, .hide-all{
        display:none;
       // background:red;
        background: rgba(74, 74, 74, 0.7);
        position:absolute;
        left:0;
        right:0;
        bottom:0;
        top:0;
        z-index:5;
    }
    .track-info{
        color: $color-white;
        position:absolute;
        left:0;
        right:0;
        bottom:0;
        padding: 0.5rem;
        z-index: 2;
        text-shadow: 0 1px 3px rgba($color-black,1);
        background-image: linear-gradient(rgba($color-black,0), rgba($color-black,0.3));
        .song-name{
            font-size: 0.8rem;
            font-weight:800;
            display:block;
            overflow:hidden;
            text-overflow: ellipsis;
            max-width:150px;
        }
        .artist-name{
            font-weight:300;
            display:block;
            padding-bottom:0.5rem;
        }
    }
    .song-rating-ui{
        display:none;

    }
    .rating-icon{

        width:50%;
    }
    .song-ui{
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        align-items: center;
        justify-content: center;

        button{
            outline:none;
            border-radius:50px;
            width:24px;
            height:24px;
            background-color: rgba($color-black, 0.5);
            border-color: rgba($color-white, 0.25);
            margin: 0;
            padding:0.25 !important;
            &:hover{
                background-color: rgba($color-black, 0.75);
                border-color: rgba($color-black, 0.75);
                .rating-icon.thumbs-up{
                    color: $color-success;
                }
                .rating-icon.thumbs-down{
                    color: $color-danger;
                }
                .rating-icon.spotify{
                    color: #1DB954;
                }
            }
            .rating-icon{
                color: rgba($color-white, 0.9);

            }
        }
        .toggle-play-button{
            width: 50%;
            height: 50%;
            max-width: 70px;
            max-height: 70px;
            display:flex;
            flex-flow: column nowrap;
            place-content:center;
            align-items:center;
            z-index:10;
            position:relative;

        }
    }

    .toggle-play.song-ui{
        display:flex;
        align-items: center;
        place-content:center;
    }
    .playing {
        z-index:100000;
        .toggle-pause{
            display:flex;
        }
        .toggle-play.song-ui{
            display:none;
        }
        .hide-me{
            display:block;
        }
    }
    .preview-player, audio{
        opacity:0;
        display:none;
      // height:50px;
    }
    .soundclip{
        border:2px solid transparent;
        .icon-play{
            display:block;
        }
        .icon-paused{
            display:none;
        }
        &.playing{
            .icon-play{
                display:none;
            }
            .icon-paused{
                display:block ;
            }
        }
    }
    .song-bar-container{
        display:flex;
        flex-direction: column;

        width:100%;
    }
    .discover-card{
        display:flex;
        flex-direction:column;
        flex:1;
        position:relative;
        width:100%;
        .duration{
            position:absolute;
            right: 0.5rem;
            top: 0.5rem;
            color: $color-white;
            font-size:0.5rem;
            text-shadow: 0 1px 3px rgba($color-black,0.1);
            display:none;
        }
    }
    .discover-card-bg{
       flex:1;
        display:flex;
        flex-flow: column nowrap;
        place-content: center;
        align-items: center;
    }
   .song-bar{
        border-radius: 3px;
        background-color: rgba(darken($global-background, 10%), 0.2);
        position:relative;
        .play-icon{
            position:absolute;
            left:8px;
            top:50%;
            transform: translateY(-50%);
            opacity:0.8;
            font-size:12px;
        }
        .duration{
            position:absolute;
            top:4px;
            right:4px;
            font-size: 0.6rem;
            font-weight: 600;
            opacity: 0.6;

        }
        .song-progress{
            background-color: rgba($color-secondary, 0.5);
            position:absolute;
            top:0;
            bottom:0;
            left:0;
            z-index:1;
        }

        .song-info{
            position:relative;
            z-index:2;
            padding: 0.15rem;
            padding-left: 30px;
            white-space: nowrap;

            display:block;
            overflow: hidden;
            text-overflow: ellipsis;

        }

    }

    .bar-view{
        .toggle-play{
            z-index:2;
            position:absolute;
            width:24px;
            height:24px;
        }
    }
    .soundtype-feature{
        .duration{
            top:0;
        }
        .song-name, .artist-name{
            text-align: left;
            padding-left:0.5rem;
        }
    }
    .soundtype-tile{
        .track-info-hover{
            border-radius:3px;
            background-color: $color-black;
            width:auto;
            white-space: nowrap;
            color: $color-white;
            padding: 0.25rem 0.5rem;
            margin-top:-30px;
        }
        .artist-name{
            padding-bottom:0;
        }
    }
    .soundtype-bar{
        border:none !important;
        .song-cite-content{
            flex:1;
            display:flex;
            flex-direction:row;
            align-items: center;
        }
        .toggle-play{
            position:relative;
            display:none !important;
        }
        .duration{
            top:0;
        }
        .spotify-link{
            display:none;
            transform: none;
            right:0;
            top:0.8rem;
            span{
                align-self: center;
                vertical-align:middle;
                opacity:0.5;
                font-size: 0.5rem;
                text-transform: uppercase;
                padding-right: 0.5rem;
            }
            &:hover{
                span{
                    color: $color-white;
                    opacity:1;
                }
            }
        }
    }
    .active .soundtype-bar .spotify-link{
        display:block;
        opacity: 0.5;
        span{
            opacity:1
        };
        &:hover{
            opacity:1;
        }
    }
    .soundtype-card, .soundtype-community, .soundtype-promotion, .soundtype-chat{
        .song-cite-content{
            flex:1;
            position:relative;
        }
        .song-bar{
            height:30px;
        }
        .song-info{
            position:absolute;
            left:0;
            right:0;
            top:0;
            bottom:0;
            overflow:hidden;
            text-overflow:ellipsis;
            display:flex;
            align-items:center;

        }
        .toggle-play{
            z-index: 3;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 25px;
            align-self: stretch;

        }
    }
    .soundtype-community, .soundtype-promotion,  .soundtype-chat{
        opacity:0.8;
        cursor:pointer;
        &:hover{
            opacity:1;
        }
        .song-actions{
            display:none;
            .spotify-link{
                position:relative;
                left:auto;
                right:auto;
                top:auto;
                bottom:auto;
                transform:none;
                display:flex;
            }
            .action-link{
                opacity:0.5;
                margin: 0.15rem;
                &:hover{
                    opacity:1;
                }
            }
        }

            .icon-play{
                display:flex;
            }
            .icon-paused{
                display:none;
            }


        .track-sidebar-cta{
            right: -2px;
            left:auto;
            top:auto;
            bottom:-26px;
            flex-direction:row;

        }
        .song-bar{
            background-color: rgba($color-black, 0.25);
            height: 15px;
            position:absolute;
            bottom: 0;
            left:0;
            right:0;
            z-index:2;
        }
        .song-info{
            left:85px;
            bottom: 25px;
            z-index:2;
            padding: 0.5rem;
            display:flex;
            align-items: flex-start;
            justify-content: center;
            text-align: left;
            flex-direction:column;
        }
        .song-cover{
            position:absolute;
            width:85px;
            height:85px;
            background-size:cover;
            z-index:3;
            top:0px;
            left:0px;
        }
        .toggle-play, .toggle-pause{
            position:absolute;
            left:0;
            right:0;
            top:0;
            bottom:0;
            width:auto;
            display:flex;
            align-items:center;
            justify-content: center;
            .toggle-play-button{
                width:30px;
                height:30px;
                border-radius: 50px;
                align-items:center;
                justify-content: center;
                background-color: rgba($color-black, 0.5);
                border-color: rgba($color-white, 0.25);


            }
            .play-icon{
                width:12px;
                height:12px;
            }
            &:hover{
                .toggle-play-button{
                    background-color: rgba($color-black, 0.75);
                }
            }
        }
        .song-name{
            font-size:1rem;
            white-space: nowrap;
            padding-right:50px;
            overflow:hidden;
            text-overflow:ellipsis;
            max-width: calc(100% - 50px);

        }
        .artist-name{
            font-size:0.7rem;
            display:block;
            opacity:0.7;
        }
        .song-duration{
            position:absolute;
            bottom:0;
            right:0.5rem;
            top:auto;
            font-size:0.7rem;

        }
    }
    .soundtype-search {
        display:flex;
        flex-direction:row;
        position:relative;
        border:none;
        flex:none;
        .card-view{
            width: 100%;
            max-height:500px;
            max-width: 500px;
            background-color: $color-white;
            border:1px solid red;
            display:flex;

            &:before{
                content:'';
                display:block;
                padding-top: 100%;
            }
        }
        .song-cover{
            position:absolute;
            top:0;
            bottom:0;
            left:0;
            right:0;
            display:flex;
            filter:none;
            opacity:1;
        }
        .cropped{
            flex:1;
        }
    }
     .song-cite.selected{
         .soundtype-community{opacity:1 !important;}
     }
    .song-cite.playing{
        .soundtype-community, .soundtype-promotion, .soundtype-search, .soundtype-chat{
            .toggle-play{
                color: rgba($color-white, 0.5) !important;
            }
            .icon-play{
                display:none !important;
            }
            .icon-paused{
                display:flex !important;
            }
        }
    }
    .selected{
        .soundtype-community{
            .song-actions{
                display:flex;
                position:absolute;
                right:0;
                top:0;
                bottom:0;
                align-items: center;
                z-index: 5;
            }
        }
    }
    .insight-track.active{
        .soundtype-bar{
            .toggle-play{
                position:static;
                display:block !important;
                margin-right: 0.5rem;
                left:auto;
                top:auto;
                right:auto;
                bottom:auto;
            }
            .icon-play, .icon-paused{
                color: rgba($color-white, 0.5);
                align-items: center;
                justify-content:center;
            }
            .song-bar{
                margin-left:0;
                flex:1;
            }


        }
    }
    .insight-track.active{
        .song-cite.playing{
            .soundtype-bar{
                .icon-play{
                    display: none !important;
                }
            }
        }
    }
    .soundtype-promotion{
        opacity:1;
        background: rgba($color-black, 0.75);
        color: $color-white;
        .background-image{
            opacity:0.8;
            filter:none;
        }
        .background-gradient{
            position:absolute;
            left:0;
            top:0;
            right:0;
            bottom:0;
            background-image: linear-gradient(rgba($color-black,0.3), rgba($color-black,0.8));
            z-index:1;
        }
        .song-info{
            left:80px;
            bottom:15px;
        }
        .song-cover{
            width:75px;
            height:75px;
        }
        .cropped{
            min-height:90px;
        }
        .disclaimer{
            font-size:0.5rem;
            font-weight:600;
            color: $color-white;
            position:absolute;
            right:0.5rem;
            top:0.5rem;
            opacity:0.5;
            text-transform: uppercase;
            z-index:2;
        }
    }
    .playing .soundtype-chat{
        border-color: lighten($color-secondary, 10%);
    }
    .soundtype-chat{
        min-width:180px;
        opacity:1;
        background: $color-black;
        color: $color-white;
        border-radius: 4px;
        border-color: rgba($color-white, 0.25);

        .background-image{
            opacity:0.8;
         //   filter:none;
        }
        .background-gradient{
            position:absolute;
            left:0;
            top:0;
            right:0;
            bottom:0;
            background-image: linear-gradient(rgba($color-black,0.3), rgba($color-black,0.8));
            z-index:1;
        }
        .song-info{
            left:35px;
            bottom:15px;
        }
        .song-cover{
            margin-left:0.15rem;
            margin-top:0.15rem;
            width:30px;
            height:30px;
        }
        .cropped{
            min-height:50px;
        }
        .song-name{
            font-size: 0.7rem;

        }
        .artist-name{
            text-align:left;
            padding-right: 50px;
            overflow:hidden;
            text-overflow:ellipsis;
            padding-left:5px;
            position:relative;
            z-index:10;
        }
        .track-sidebar-cta{
            right:0;
        }

    }
    .soundtype-card, .soundtype-suggestion{
        .song-name-list{
            position: absolute;
            left: 35px;
            right: 50px;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
    .soundtype-suggestion{
        color: $color-darkgray;

        .toggle-play{
            position:absolute;
            width:25px;
            height:25px;
            left:2.5px;
            top:50%;
            z-index:115;
            transform: translateY(-50%);
            border-radius: 50px;
            align-items:center;
            justify-content: center;
            background-color: rgba($color-black, 0.5);
            border-color: rgba($color-white, 0.25);
            color: $color-white;
            .icon-play, .icon-pause{
                color: $color-white !important;
            }
        }
        .cropped{
            min-height: 50px;
            position:relative;
        }
        .song-info{
            left:30px;
            bottom: 0;
            top:0;
            right:0;
            display:block;
            padding-left:0;
            position:absolute;
            .song-name{
                font-weight: 600;
                font-size:0.8rem;
            }
        }
        .song-cover{

            width:30px;
            height:30px;
            background-size:cover;
            z-index:3;
            position:relative;
            z-index:1;

        }
        .song-name-list{
            padding-top:3px;
            left:0.5rem;
        }
        .background-image, .background-gradient{
            opacity:0;
            display:none;
        }
        .song-cite-content{
            flex:1;
            background-color: darken($color-gray, 2%);
        }
        .background-image{
            filter: blur(20px);
        }
    }
    .soundtype-cover{
        position:relative;
        .song-bar{
            position:absolute;
            bottom:0;
            left:0;
            right:0;
        }
        .discover-card-bg{
            position:absolute;
            top:0;
            bottom:0;
            left:0;
            right:0;
            .duration{
                top:0.5rem;
                right:0.5rem;
                color: $color-white;
                position:absolute;
                z-index:2;
                margin:0;
            }
            .song-name{
                color: $color-white;
                font-size:1.25rem;
                font-weight: 300;
                position:absolute;
                bottom:0.25rem;
                left:0.5rem;
                right:0.5rem;
                overflow:hidden;
                text-overflow:ellipsis;
                z-index:2;
            }
            .spotify-link{
                position:absolute;
                left:0.5rem;
                top:0.5rem;
                display:block;
                z-index:11;
                color: $color-white;
                &:hover{

                    color: #1DB954;
                }
            }
        }
        .song-rating-ui, .toggle-play{
            z-index:10;
        }
        .background-gradient{
            position:absolute;
            left:0;
            top:0;
            right:0;
            bottom:8px;
            background-image: linear-gradient(rgba($color-black,0.3), rgba($color-black,0.0), rgba($color-black,0.8));
            z-index:1;
        }
    }

    .song-bar-container .soundtype-suggestion .song-progress{
        background-color: rgba($color-secondary,0.5) !important;
    }
    .soundtype-tradeMarket{
        border: none !important;
        overflow:hidden;
        position:relative;
        .discover-card{
            display:flex;
            flex-direction:row;
        }
        .trade-cover{
            width: 50px;
            height:50px;
            z-index:2;
            position:relative;
            display:flex;
            flex-direction:column;
            align-content:center;
            justify-content:center;
        }
        .background-gradient{
            position:absolute;
            left:0;
            top:0;
            right:0;
            bottom:8px;
            background-image: linear-gradient(to top,rgba($color-black,0.5), rgba($color-black,0.8));
            z-index:1;
        }
        .song-ui{
            bottom:0;
            .toggle-play-button{
                width:30px;
                height:30px;
                box-sizing:border-box;
                padding:0;

            }
        }
        .background-gradient{
            bottom: 0;
        }

        .song-info{
           z-index:3;
           position:absolute;
           top:0;
           left:60px;
           bottom:0;
           right:0;
           .song-name, .artist-name{
               color: $color-white;
               white-space: nowrap;
               overflow:hidden;
               text-overflow: ellipsis;
               display:block;
               margin:0;
               padding:0;
           }
           .song-name{
               font-size: 0.8rem;
               font-weight: 600;
               color: $color-white;
           }
           .artist-name{
               font-size: 0.65rem;
           }
           .info{
               position:absolute;
               left:0;
               top:0;
               bottom:0;
               right: 30px;
               white-space: nowrap;
               overflow:hidden;
               text-overflow: ellipsis;
               display:flex;
               flex-direction:column;
               justify-content: center;

           }
           .supplement{

               position:absolute;
               bottom:0;
               top:0;
               right:0;
               padding-top: 2px;
               padding-right: 5px;
               text-align:center;
               .duration, .spotify-link{
                   position:static;
                   min-width:30px;
               }
               .duration{
                   font-size: 0.6rem;
                   text-align:center;
                   margin-bottom:0;
               }
               .spotify-link{
                   font-size: 14px;
                   color: $color-white;
                   display:block;
                   text-align:center;
                   margin:0;
                   margin-top:2px;
               }
           }
        }
        .blurred-bg{
            filter: blur(20px);
            position:absolute;
            top:-20px;
            left:-20px;
            right:-20px;
            bottom:-20px;
            z-index:1;
        }
        .discover-card-bg{
            width:150px;
            height:150px;
            flex:none;
            position:relative;
            align-self:center;
            z-index:2;
            box-shadow: 0 0 100px 50px rgba($color-black, 0.8);
        }
    }
    .soundtype-tradeProposal{
        .discover-card{
            bottom:0;
            top:0;
            left:0;
            right:0;
            position:absolute;
        }
        .discover-card-bg{
            position:relative;
        }
        .duration-container{
            position:absolute;
            bottom:0;
            left:0;
            right:0;
            z-index:5;
            text-align:left;
            background: linear-gradient(to top, rgba($color-black,1), rgba($color-black,0.0));
            display:block;
            .duration{
                position:static;
                margin:0;
                padding-left: 0.5rem;
                padding-bottom: 0.25rem;
                display:inline-block;
                font-size: 0.65rem;
            }
            .spotify-link{
                position:absolute;
                bottom: 0;
                right:0.5rem;
                z-index: 5;
                color: $color-white;
                display:block;
            }
        }
        .song-info{
            background-color: $color-black;
            color: $color-white;

            .song-name, .artist-name{
                margin:0;
                color: inherit;
                white-space: nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }
            .song-name{
                font-size: 0.8rem;
                font-weight: 500;
            }
            .artist-name{
                font-size: 0.6rem;
            }
        }
    }
    .tooltip{
        span{
            border-left: 1px solid $color-darkgray;
            padding-left: 1rem;
            margin-right: 1rem;
            &:first-child{
                padding-left:0;
                border-left:none;
            }
            &:last-child{
                margin-right: 0;
            }
        }
    }
    .soundtype-recentsearch{
        display:flex;
        position:relative;
        color: $color-darkgray;
        align-items: flex-start;
        padding:0;
        margin-bottom: 5px;

         padding: 4px 4px 6px 4px;
        .cover{
            display:flex;
            align-items:center;
            justify-content: center;
            width: 60px;
            height: 60px;
            background-position:center center;
            background-repeat:no-repeat;
            background-size:cover;
            border:1px solid $color-white;
            .toggle-play{
                width:50%;
            }
        }
        .info{
            flex:1;
            position:absolute;
            left: 70px; right: 7px;
            top:4px; bottom:0;
            overflow:hidden;

            .song-details{
                text-align:left;
                position:relative;
                overflow:hidden;
                padding-right: 40px;


                .song-name, .artist-name{
                    display:block;
                    white-space: nowrap;
                    overflow:hidden;
                    text-overflow: ellipsis;
                }
                .song-name{
                    font-size: 0.8rem;
                }
                .artist-name{
                    font-size: 0.6rem;
                }
            }
            .song-duration{
                    position:absolute;
                    right:0;
                    top:0;
                    font-size: 0.6rem;
                    text-align:right;
                }
            .song-duration{
                width: 60px;
            }

        }
        button{
            background: transparent;
            color: darken($color-gray, 20%);
            border-radius:0;
            padding: 0.5rem 0.65rem;
        }
        .cta-icon{
            font-size: 14px;
            width:14px;
            height:14px;
        }
        .sidebar-cta{
            position:absolute;
            bottom:0;
            right:0;
        }
        &:hover{
            button{
                background: $color-secondary;
                color: $color-white;
                &:hover{
                    background: lighten($color-secondary, 10%);
                }
            }
        }
    }
    .selected .soundtype-recentsearch{
        button{
            background: $color-secondary;
            color: $color-white;
        }
    }
    .soundtype-searchdetail{
        display:flex;
        position:relative;
        align-self:center;
        background: white;
        padding:1rem;
        @extend .shadow;

        .sidebar-cta{
            flex:1;
            display:flex;
            max-width: 500px;
            flex-direction: column;
            margin-left:1rem;
            justify-content: flex-start;
            h6{
                padding:1rem;
                text-transform: uppercase;
                text-align:left;
                font-size: 0.6rem;
                border-bottom:1px solid $color-gray;
            }
            button{
                color: $color-darkgray;
                background: transparent;
                font-size: 1rem;
                display:flex;
                padding:  1rem ;
                justify-content: space-between;
                border-radius: 0;
                text-align:left;
                white-space:nowrap;
                .cta-icon{
                    margin-left:2rem;
                    color: darken($color-gray, 20%);
                    font-size: 18px;
                }
                &:hover{
                    background-color: $color-secondary;
                    color: $color-white;
                    .cta-icon{
                        color: $color-white;
                    }
                }
            }
        }

        .cover-container{
            display:flex;
            align-items:center;
            justify-content: center;
            width: 25vw;
            max-width:500px;
            max-height:calc(100vh - 320px);
            position:relative;
             &:before{
                content: "";
                display: block;
                padding-top: 100%;
            }
        }
        .cover{

            background-position:center center;
            background-repeat:no-repeat;
            background-size:cover;
            color: $color-white;
        }

        .info{
            position:absolute;
            bottom:5px;
            left:0;
            right:0;
            z-index:10;
            display:flex;
            flex-direction:column;
            align-items: flex-start;
            padding: 0.5rem;
            @extend .gradient;
            span{
                padding: 0.25rem 1rem;
            }
            .song-name{
                font-size:1.25rem;
                font-weight: 600;
                @extend .text-shadow;
            }
            .artist-name{
                @extend .text-shadow;
                padding-right: 75px;
            }

        }
        .song-duration{
            position:absolute;
            right:1rem;
            bottom:.75rem;
            @extend .text-shadow;
        }
        .status-bar{
            height:5px;
            position:absolute;
            bottom:0;
            left:0; right:0;
            z-index:10;
            background: $color-darkgray;
            .song-progress{
                height:5px;
                background-color: $color-secondary;

            }
        }

    }
    .cover{
        cursor:pointer;
        .toggle-play{

            display:flex;
            color: $color-white;

            z-index:20;
            border-radius: 1000px;
            flex-direction:row;
            align-items:stretch;
            justify-content: stretch;
            .toggle-play-button{

                align-items:center;
                justify-content: center;
                display:flex;
                opacity:0.76;
                align-self: center;
                margin:auto;
                .play-icon{
                    font-size:none;
                    width:36%;
                    height:36%;
                }
            }
            .icon-paused{
                display:none;
            }
             &:before{
                content: "";
                display: block;
                padding-top: 100%;
            }
        }
        &:hover{
            .toggle-play-button{
                opacity:1;
            }
        }
    }
    .playing{
        .cover .toggle-play{
            .icon-play{
                display:none !important;
            }
            .icon-paused{
                display:flex !important;
            }
        }
    }
</style>
